import type { User as FirebaseUser } from "@firebase/auth";

/**
 * Force a Firebase ID token refresh so newly-set custom claims (e.g.
 * organization_id) reach Supabase on the next query. Non-fatal: a failed
 * refresh must not block sign-in (the cached token still works).
 */
export async function ensureFreshToken(
  user: Pick<FirebaseUser, "getIdToken">
): Promise<void> {
  try {
    await user.getIdToken(true);
  } catch {
    // Non-fatal — keep going with the existing cached token.
  }
}
